import { render } from "./asc-button.vue?vue&type=template&id=6644c7be&scoped=true"
import script from "./asc-button.vue?vue&type=script&lang=js"
export * from "./asc-button.vue?vue&type=script&lang=js"

import "./asc-button.vue?vue&type=style&index=0&id=6644c7be&scoped=true&lang=scss"

import exportComponent from "/opt/TeamCity/buildAgent/work/f19c936fb20a8ac2/vue-embed/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6644c7be"]])

export default __exports__